import Helmet from "react-helmet";

import { Outlet } from "react-router-dom";

import { getPageTitle } from "@utils";

import ResidentsTable from "./ResidentsTable";

export default function Residents() {
  return (
    <>
      <Helmet>
        <title>{getPageTitle("Residents")}</title>
      </Helmet>
      <ResidentsTable />
      <Outlet />
    </>
  );
}
